import { Context, Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import Molten from '@leverege/molten';
import { AllowedReducer } from '@leverege/api-redux';
import AddAdditionalTagsDialog from './AddAdditionalTagsDialog';
import RecovrSales from '../../util/RecovrSales';
export default {
  id: 'recovr.addAdditionalTagsToSale',
  name: 'Add Additional Tags to Sale',
  layout: {
    sort: 'recovrSaleActions.downloadAgreement.j',
    sectionName: 'RecovR Sale Actions'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return false;
    }
    const parentPath = Config.get('VoidSale', 'saleLocationParentPath', 'location');
    const actions = DataSources.getActions(targets[0]);
    return RecovrSales.canAddAdditionalTagsToSale({
      sale: targets[0].data,
      locationId: targets[0].data?.data?.[parentPath]?.id,
      actions
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.addAdditionalTagsToSale != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.addAdditionalTagsToSale === true && targets[0]?.data?.data?.type === 'vehicle-with-locator' && targets[0]?.data?.data?.productTypes?.recovrKeys === true && targets[0]?.data?.data?.state === 'sold';
  },
  appearance: () => {
    return {
      name: 'Add Additional Tags to Sale'
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const sale = Context.getTargetsOfType(context, 'sale')[0];
    const actions = DataSources.getActions(sale);
    if (!sale) {
      return;
    }
    let keysWithTags = {};
    const systemId = Molten.getConfig('api/systemId');
    if (sale?.data?.data?.keys) {
      for (const [k, v] of Object.entries(sale?.data?.data?.keys)) {
        const cacheKeyData = GlobalState.get().models.lookup?.[k];
        if (v['tagId']) {
          if (cacheKeyData) {
            keysWithTags = {
              ...keysWithTags,
              [k]: {
                key: cacheKeyData
              }
            };
          } else {
            keysWithTags = {
              ...keysWithTags,
              [k]: {
                key: await GlobalState.dispatch(async (dispatch, getState, {
                  api
                }) => api.interface(systemId, 'key').obj(k).get())
              }
            };
          }
        }
      }
    }
    Dialogs.show({
      id: 'addAdditionalTag',
      component: AddAdditionalTagsDialog,
      props: {
        sale,
        actions,
        keysWithTags
      }
    });
  }
};